var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayoutActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30498",
    "data-name": "Group 30498",
    transform: "translate(10593 -17468)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14185",
    "data-name": "Rectangle 14185",
    width: 32,
    height: 32,
    transform: "translate(-10593 17468)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layout_1_",
    "data-name": "layout (1)",
    transform: "translate(-10590 17471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14228",
    "data-name": "Rectangle 14228",
    width: 20,
    height: 20,
    rx: 2,
    transform: "translate(3 3)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1019",
    "data-name": "Line 1019",
    x2: 20,
    transform: "translate(3 9.667)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1020",
    "data-name": "Line 1020",
    y1: 12,
    transform: "translate(9.667 11)",
    fill: "none",
    stroke: "#1447d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutActive);
export default __webpack_public_path__ + "static/media/layoutActive.f81a0f9e.svg";
export { ForwardRef as ReactComponent };